import { GradientButton } from '@/pages/Studio/components';
import { useResize } from '@/hooks/useResize';

import * as Styles from './WordPressAIHighlight.styles';

import WordPressLogo from '@/pages/Home/media/wordpress-logo.png';
import React from 'react';
import { DivContents, DivImg } from '../HGStudioHighlight/HGStudioHighlight.styles';

const WordPressAIHighlight = ({
  element,
  buttonIsLoading = false,
}) => {
  const windowRect = useResize();
  const { width: windowWidth } = windowRect;
  const mobile = windowWidth < 600;

  return (
    <DivContents id={element.id} key={element.id} data-testid={`highlight-${element.id}`}>
      <DivImg>
        <img
          src={element.image}
          alt="produto em destaque"
        />
      </DivImg>

      <Styles.DivText>
        <Styles.WrapperTitle>
          <Styles.Title data-testid={`title-${element.id}`}>{element.title}</Styles.Title>
          <img src={WordPressLogo} alt="WordPress Logo" />
        </Styles.WrapperTitle>

        <Styles.Subtitle data-testid={`subtitle-${element.id}`}>
          {element.subtitle}
        </Styles.Subtitle>

        <Styles.Description data-testid={`description-${element.id}`}>
          {element.description}
        </Styles.Description>

        <Styles.ButtonWrapper>
          <GradientButton
            testId="cta"
            label={element.cta.label}
            variant="quaternary"
            size="lg"
            version="v2"
            width={mobile ? 'full' : 'fit-content'}
            onClick={element.cta.onClick}
            loading={buttonIsLoading}
            disabled={buttonIsLoading}
          />
        </Styles.ButtonWrapper>
      </Styles.DivText>
    </DivContents>
  );
};

export default WordPressAIHighlight;
